import './App.css';
import {
    Badge,
    Button,
    Card,
    Checkbox,
    Divider,
    Flex,
    Form,
    Input,
    message,
    Modal,
    Skeleton,
    Space,
    Typography,
} from 'antd';
import useSWR, { useSWRConfig } from 'swr';
import 'react-quill/dist/quill.snow.css';
import cookie from 'react-cookies';

import { useNavigate } from 'react-router-dom';
import { LeftCircleOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { Title } = Typography;

const fetcher = async (url: string) => {
    const token = cookie.load('token');
    const res = await fetch(url, {
        headers: new Headers({
            'Access-Control-Allow-Origin': '*',
            Authorization: `Bearer ${token}`,
        }),
    });
    const json = await res.json();
    if (!json.success) {
        const error = new Error((await json).message);
        throw error;
    }
    return json;
};

const MarshmallowCategory = () => {
    const { mutate } = useSWRConfig();
    const [form] = Form.useForm();
    const [renameForm] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [renameOpen, setRenameOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(0);
    const [renameId, setRenameId] = useState(0);
    const token = cookie.load('token');
    const onCreate = async (values: any) => {
        setOpen(false);
        const apiResponse = await (
            await fetch(
                'https://api.lynne.com.cn/marshmallowManage/addCategory',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        name: values.name,
                        select: values.select === true,
                    }),
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`,
                        'Content-type': 'Application/json',
                    }),
                }
            )
        ).json();
        if (apiResponse.success) {
            message.success(apiResponse.message);
            mutate('https://api.lynne.com.cn/marshmallowManage/category');
        } else {
            message.error(apiResponse.message);
        }
    };

    const onEdit = async (values: any) => {
        const apiResponse = await (
            await fetch(
                'https://api.lynne.com.cn/marshmallowManage/selectCategory',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        id: values.id,
                    }),
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`,
                        'Content-type': 'Application/json',
                    }),
                }
            )
        ).json();
        if (apiResponse.success) {
            message.success(apiResponse.message);
            mutate('https://api.lynne.com.cn/marshmallowManage/category');
        } else {
            message.error(apiResponse.message);
        }
    };

    const onRename = async (values: any) => {
        setRenameOpen(false);
        const apiResponse = await (
            await fetch(
                'https://api.lynne.com.cn/marshmallowManage/renameCategory',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        id: renameId,
                        name: values.name,
                    }),
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`,
                        'Content-type': 'Application/json',
                    }),
                }
            )
        ).json();
        if (apiResponse.success) {
            message.success(apiResponse.message);
            mutate('https://api.lynne.com.cn/marshmallowManage/category');
        } else {
            message.error(apiResponse.message);
        }
    };

    const onDelete = async () => {
        setDeleteOpen(false);
        const apiResponse = await (
            await fetch(
                'https://api.lynne.com.cn/marshmallowManage/deleteCategory',
                {
                    method: 'POST',
                    body: JSON.stringify({
                        id: deleteId,
                    }),
                    headers: new Headers({
                        'Access-Control-Allow-Origin': '*',
                        Authorization: `Bearer ${token}`,
                        'Content-type': 'Application/json',
                    }),
                }
            )
        ).json();
        if (apiResponse.success) {
            message.success(apiResponse.message);
            mutate('https://api.lynne.com.cn/marshmallowManage/category');
        } else {
            message.error(apiResponse.message);
        }
    };

    const {
        data: categoryData,
        error: categoryError,
        isLoading: categoryIsLoading,
    } = useSWR('https://api.lynne.com.cn/marshmallowManage/category', fetcher);
    const n = useNavigate();
    if (categoryIsLoading || categoryData === undefined)
        return <Skeleton active />;
    if (categoryError) {
        cookie.remove('token');
        n('/login');
    }
    const categorySelected = categoryData.data.filter(
        (c: { selected: number }) => c.selected === 1
    )[0];

    // 渲染数据
    return (
        <>
            <Modal
                open={open}
                title='添加分类'
                okText='添加'
                cancelText='取消'
                okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
                onCancel={() => setOpen(false)}
                destroyOnClose
                modalRender={dom => (
                    <Form
                        layout='vertical'
                        form={form}
                        name='addCategory'
                        clearOnDestroy
                        onFinish={values => onCreate(values)}>
                        {dom}
                    </Form>
                )}>
                <Form.Item
                    name='name'
                    label='名称'
                    rules={[
                        {
                            required: true,
                            message: '请输入分类名称',
                        },
                    ]}>
                    <Input />
                </Form.Item>
                <Form.Item name='select' valuePropName='checked'>
                    <Checkbox checked>设置为默认分类</Checkbox>
                </Form.Item>
            </Modal>
            <Modal
                open={renameOpen}
                title='重命名分类'
                okText='编辑'
                cancelText='取消'
                okButtonProps={{ autoFocus: true, htmlType: 'submit' }}
                onCancel={() => setRenameOpen(false)}
                destroyOnClose
                modalRender={dom => (
                    <Form
                        layout='vertical'
                        form={renameForm}
                        name='renameCategory'
                        clearOnDestroy
                        onFinish={values => onRename(values)}>
                        {dom}
                    </Form>
                )}>
                <Form.Item
                    name='name'
                    label='名称'
                    rules={[
                        {
                            required: true,
                            message: '请输入新的分类名称',
                        },
                    ]}>
                    <Input />
                </Form.Item>
            </Modal>
            <Modal
                open={deleteOpen}
                title='确认删除喵？'
                okText='删除'
                okType='danger'
                cancelText='取消'
                onCancel={() => setDeleteOpen(false)}
                onOk={() => onDelete()}
                destroyOnClose>
                这个分类会被永远删除喵！（如果分类下还有稿件会删除失败~防止误删）
            </Modal>
            <Flex align='center' gap={10}>
                <Button
                    type='primary'
                    shape='circle'
                    icon={<LeftCircleOutlined />}
                    onClick={() => n('/dashboard')}
                />
                <Title level={3} style={{ margin: '15px 0', flex: 1 }}>
                    投稿分类管理
                </Title>
            </Flex>
            <Title level={5} style={{ margin: '15px 0' }}>
                当前默认投稿分类：{categorySelected.name}
            </Title>
            <Flex align='center' gap={10}>
                <Button type='primary' onClick={() => setOpen(true)}>
                    添加分类
                </Button>
                <Button type='primary' onClick={() => n('/dashboard/archived')}>
                    收纳管理
                </Button>
            </Flex>
            <Divider />
            <Space
                direction='vertical'
                size={'middle'}
                style={{ width: '100%' }}>
                {categoryData.data.map(
                    (category: {
                        id: number;
                        name: string;
                        selected: number;
                    }) => {
                        return (
                            <div key={category.id}>
                                <Card
                                    bordered={false}
                                    style={{ width: '100%' }}>
                                    <Flex align='middle' gap={10} wrap>
                                        <Space style={{ flex: 1 }}>
                                            {category.name}
                                            {category.selected === 1 && (
                                                <Badge
                                                    color='blue'
                                                    count='当前默认分类'
                                                />
                                            )}
                                        </Space>
                                        <Button
                                            type='primary'
                                            onClick={() => {
                                                setRenameOpen(true);
                                                setRenameId(category.id);
                                            }}>
                                            重命名分类
                                        </Button>
                                        <Button
                                            type='primary'
                                            onClick={() =>
                                                onEdit({ id: category.id })
                                            }>
                                            设为默认分类
                                        </Button>
                                        <Button
                                            type='primary'
                                            danger
                                            onClick={() => {
                                                if (
                                                    categoryData.data.length ===
                                                    1
                                                ) {
                                                    message.error(
                                                        '等等这是最后一个分类了喵！'
                                                    );
                                                    return;
                                                }
                                                setDeleteId(category.id);
                                                setDeleteOpen(true);
                                            }}>
                                            删除分类
                                        </Button>
                                    </Flex>
                                </Card>
                            </div>
                        );
                    }
                )}
            </Space>
        </>
    );
};

export default MarshmallowCategory;
